import {BaseForm} from '@management-ui/core';
import * as React from 'react';
import {forwardRef, useCallback, useContext, useImperativeHandle, useRef} from 'react';
import {ServiceContext} from '../../../../components/Services';
import Fields from './Fields';

const ContactLocationForm = forwardRef(({contact, location, onSaved}, ref) => {
  const services = useContext(ServiceContext);
  /** @type {({current: BaseForm})} */
  const formRef = useRef(null);

  useImperativeHandle(ref, () => ({
    save() {
      formRef.current.save();
    }
  }));

  return (
    <BaseForm
      ref={formRef}
      entity={location}
      type="location"
      fieldsComponent={Fields}
      onSave={useCallback(({name, address1, address2, town, region, postcode, country, is_invoicing}) => (
        services.contact.location.saveLocation(contact, {
          ...(location?.id ? {id: location.id} : {}),
          name,
          address1,
          address2,
          town,
          region,
          postcode,
          country,
          is_invoicing
        })
      ), [services, contact, location])}
      onSaved={onSaved}
    />
  );
});

export default ContactLocationForm;
